import { z } from "zod";

export const adventParticipationSchema = z.object({
  day: z.number().int().min(1).max(24),
  name: z.string().trim().min(2, "Bitte gib deinen vollständigen Namen an.").max(80),
  email: z.string().trim().email("Bitte gib eine gültige E-Mail-Adresse an.").max(255),
  street: z.string().trim().min(3, "Bitte gib Straße und Hausnummer an.").max(160),
  postalCode: z.string().trim().regex(/^[\p{L}\p{N} -]{2,20}$/u, "Bitte überprüfe die Postleitzahl."),
  city: z.string().trim().min(2, "Bitte gib deinen Wohnort an.").max(100),
  country: z.string().trim().min(2, "Bitte gib dein Land an.").max(80),
  consent: z.literal(true, { error: "Bitte stimme den Teilnahmebedingungen und der Datenverwendung zu." }),
});